import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { HeaderState } from "./header.state";
import { getHeader } from "./header.thunk";
import { HeaderData, HeaderResponse } from "./header.types";

const initialState: HeaderState = {
  data: null,
  status: "idle",
  error: null,
};

export const headerSlice = createSlice({
  name: "header",
  initialState,
  reducers: {
    resetHeader: (state) => {
      state.data = null;
      state.status = "idle";
      state.error = null;
    },
    // SSR'dan gelen initial header verisini store'a yaz (ISR cache hit)
    setHeader: (state, action: PayloadAction<HeaderData>) => {
      state.data = action.payload;
      state.status = "success";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getHeader.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(
        getHeader.fulfilled,
        (state, action: PayloadAction<HeaderResponse>) => {
          state.status = "success";
          state.data = action.payload.data;
        },
      )
      .addCase(
        getHeader.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = "error";
          state.error =
            action.payload ?? "Header verileri yüklenirken bir hata oluştu.";
        },
      );
  },
});

export const { resetHeader, setHeader } = headerSlice.actions;

export default headerSlice.reducer;
